// Fontes usadas exclusivamente pelo seletor de fonte da página de bio
// (BiographySmartphoneView.vue, id 1-9). Carregadas sob demanda para não
// pesar o LCP das páginas públicas de marketing, que só usam Montserrat
// (já carregada globalmente em public/index.html).
const BIO_FONTS_HREF = 'https://fonts.googleapis.com/css2?' + [
  'family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
  'family=Open+Sans:ital,wght@0,300..800;1,300..800',
  'family=Lora:ital@0;1',
  'family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900',
  'family=Raleway:ital,wght@0,100..900;1,100..900',
  'family=Noto+Serif+Oriya',
  'family=Architects+Daughter',
  'family=Permanent+Marker',
].join('&') + '&display=swap'

const LINK_ID = 'bio-fonts-stylesheet'

export function loadBioFonts() {
  if (document.getElementById(LINK_ID))
    return

  const link = document.createElement('link')
  link.id = LINK_ID
  link.rel = 'stylesheet'
  link.href = BIO_FONTS_HREF
  document.head.appendChild(link)
}
